import toast from 'react-hot-toast';
import { client } from '@/services/api/axios.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

export type CreateApiKeyResponse = {
  keyId: string;

  name: string;
  key: string;
  partialHint: string;

  status: 'active';
};

export const useCreateApiKeyMutation = (
  {
    onSuccess,
  }: {
    onSuccess?: (data: CreateApiKeyResponse) => void;
  } = { onSuccess: () => {} }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ name }: { name: string }) => {
      const promise = client.post<{ body: CreateApiKeyResponse }>(`/auth/keys`, {
        name,
      });

      const { data } = await toast.promise(promise, {
        loading: 'Creating API Key...',
        success: 'Created API Key successfully',
        error: (error) => {
          if (axios.isAxiosError(error)) {
            return error?.response?.data?.message || 'Failed to create API Key';
          }
          return error instanceof Error ? error.message : 'Failed to create API Key';
        },
      });

      return data.body;
    },
    onSuccess: (data) => {
      if (onSuccess) onSuccess(data);
    },
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: ['auth', 'keys'],
      });
    },
  });
};
